import { render, staticRenderFns } from "./reviewDeletedJob.vue?vue&type=template&id=8d764396&scoped=true"
import script from "./reviewDeletedJob.vue?vue&type=script&lang=js"
export * from "./reviewDeletedJob.vue?vue&type=script&lang=js"
import style0 from "./reviewDeletedJob.vue?vue&type=style&index=0&id=8d764396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d764396",
  null
  
)

export default component.exports